import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { exportAllSites, exportAllSitesLimenet } from '@api/exportCells';

import { IExportAllCellsDTO } from '@interfaces/cells/dto/cellsDTO';

import { ESnackbarTypes, EVendorsValues } from '@enums/common';

import { EXPORT_ALL_CELLS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

type TExportAllMutation = {
	dto: IExportAllCellsDTO;
	vendor: string;
};

export const useMutateExportAllSites = () => {
	const dispatch = useAppDispatch();

	const {
		mutate: handlePreparingExportAllSites,
		isLoading: isLoadingExportAllSites,
	} = useMutation<TExportAllMutation>({
		mutationKey: [EXPORT_ALL_CELLS],
		mutationFn: ({ vendor, dto }: TExportAllMutation) => {
			switch (vendor) {
				case String(EVendorsValues.limenet):
					return exportAllSitesLimenet(dto);
				case String(EVendorsValues.nokia):
					return exportAllSites(dto);
				default:
					return Promise.resolve({});
			}
		},
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportStartingSuccess,
				type: ESnackbarTypes.success,
			}));
		},
		refetchOnWindowFocus: false,
	});

	return {
		handlePreparingExportAllSites,
		isLoadingExportAllSites,
	};
};
